export default __webpack_public_path__ + "static/3-5b035b30936aeb3932cddafb395d34ec.jpg";